import React, { Suspense, useEffect } from "react"
import { Navigate, Route, Routes } from "react-router"
// import ReloadPrompt from "@/components/feedback/ReloadPrompt"
import { ErrorBoundary } from "react-error-boundary"
import AppLoader from "@/components/feedback/AppLoader"
import dayjs from "dayjs"
import BaseLayout from "@/layouts/BaseLayout"
import { useAtom } from "jotai"
import { appLoaderAtom } from "@/atoms/app.atom"
import { useClientInit } from "@/hooks/useClient"
// import Login from "@/pages/auth/Login"
import { ProtectedRoute } from "@/components/utilities/ProtectedRoute"
import ConfirmModal from "@/components/base/ConfirmModal"
import { store } from "@/stores/stores"
// import Register from "@/pages/auth/Register"
// import AuthLayout from "@/layouts/AuthLayout"
// import RegisterVerifyEmail from "@/pages/auth/RegisterVerifyEmail"
// import RegisterEmailPassword from "@/pages/auth/RegisterEmailPassword"
// import LoginEmailPassword from "@/pages/auth/LoginEmailPassword"
// import CreateWorkspace from "@/pages/auth/CreateWorkspace"
// import { authClient, useSession } from "@/lib/auth-client"
// import LoginMagicLink from "@/pages/auth/LoginMagicLink"
import "dayjs/locale/pt-br"
// import { AuthWorkspaceLayout } from "./layouts/AuthWorkspaceLayout"
// import { ChooseWorkspace } from "./pages/auth/ChooseWorkspace"
import Settings from "./pages/Settings"
import ScenariosRouter from "./pages/Scenarios/Scenarios.router"
import AuthKinbox from "./pages/auth/AuthKinbox"
import { useSnapshot } from "valtio"
import relativeTime from "dayjs/plugin/relativeTime"
// import Settings from "@/pages/Settings"
// import ScenariosRouter from "@/pages/Scenarios/Scenarios.router"
dayjs.extend(relativeTime)
dayjs.locale('pt-br"')

export const kinboxUrl = import.meta.env.PROD ? "https://go.kinbox.com.br" : "http://localhost:5173"

function App() {
  const snap = useSnapshot(store)

  const [appLoader] = useAtom(appLoaderAtom)
  useClientInit()
  // const { data, isPending, error } = useSession()
  // const {
  //   data: activeOrganization,
  //   isPending: isActiveOrganizationPending,
  //   error: activeOrganizationError,
  // } = authClient.useActiveOrganization()

  // useMock({ client })

  // Main
  useEffect(() => {
    // Spin.setDefaultIndicator(<Spin indicator={<Loading size={24} />} />)

    store.app.loaded = true
  }, [])

  useEffect(() => {
    try {
      document.getElementById("initial-loading-wrapper")!.style.opacity = "0"
      document.getElementById("initial-loading-wrapper")!.style.zIndex = "-1"

      setTimeout(() => {
        const element = document.getElementById("initial-loading-wrapper")
        if (element) {
          element.remove()
        }
      }, 1000)
    } catch {}
  }, [])

  // useEffect(() => {
  //   if (!isActiveOrganizationPending && activeOrganization) {
  //     store.session.actions.saveCurrentWorkspace(activeOrganization)
  //   }
  // }, [activeOrganization, isActiveOrganizationPending, activeOrganizationError])

  return (
    <ErrorBoundary
      onError={(error, info) => {
        console.log(error, info)
      }}
      fallback={<></>}
    >
      <Suspense fallback={<AppLoader />}>
        {appLoader && <AppLoader />}
        <Routes>
          {/* <Route path="/auth/*" element={<AuthLayout />}>
            <Route path="login" element={<Login />} />
            <Route path="login/email-password" element={<LoginEmailPassword />} />
            <Route path="login/magic-link" element={<LoginMagicLink />} />
            <Route path="register" element={<Register />} />
            <Route path="register/email-password" element={<RegisterEmailPassword />} />
            <Route path="register/verify-email" element={<RegisterVerifyEmail />} />
            <Route index path="*" element={<Navigate replace to="/auth/login" />} />
          </Route>
          <Route path="/workspaces/*" element={<AuthWorkspaceLayout />}>
            <Route path="create" element={<CreateWorkspace />} />
            <Route index path="*" element={<ChooseWorkspace />} />
          </Route> */}
          <Route path="/auth/kinbox/*" element={<AuthKinbox />} />
          <Route
            path="*"
            element={
              <ProtectedRoute>
                <BaseLayout />
              </ProtectedRoute>
            }
          >
            <Route path="scenarios/*" element={<ScenariosRouter />} />
            {/* <Route path="settings/*" element={<Settings />} /> */}
            <Route index path="*" element={<Navigate replace to={{ pathname: "/scenarios", hash: location.hash }} />} />
          </Route>
          <Route index path="*" element={<Navigate replace to={{ pathname: "/scenarios", hash: location.hash }} />} />
        </Routes>
        <Settings />
        {/* <ReloadPrompt /> */}
        {snap.app.modals?.map((modal) => modal.component)}
        <ConfirmModal />
      </Suspense>
    </ErrorBoundary>
  )
}

export default App
